var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.195263 0.202772C0.435586 -0.0467936 0.81374 -0.065991 1.07527 0.14518L1.13807 0.202772L8 7.32808L14.8619 0.202772C15.1023 -0.0467936 15.4804 -0.065991 15.7419 0.14518L15.8047 0.202772C16.0451 0.452338 16.0635 0.845036 15.8602 1.11662L15.8047 1.18184L8.47141 8.79723C8.23108 9.04679 7.85293 9.06599 7.5914 8.85482L7.5286 8.79723L0.195263 1.18184C-0.0650864 0.91148 -0.0650864 0.473135 0.195263 0.202772Z",
    fill: "#081C38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.59d13a1b78ca0a28f86b5fc4b3efacfe.svg";
export { ForwardRef as ReactComponent };